module.exports = __webpack_public_path__ + "img/pusheen_sherlock.dd9caa03.png";